import * as c from "../../constants/journal";

export const defaultState = {
  selectedPage: c.JOURNAL_INTRO,
  finalReflection: "",
  designSummary: "",
  showDesignSummary: true,
  selectedConceptName: null,
  selectedRevisionId: null
};

const journal = (state = defaultState, action = undefined) => {
  switch (action.type) {
    case c.JOURNAL_LOAD:
      return {
        ...state,
        finalReflection: action.journal.finalReflection,
        designSummary: action.journal.designSummary
      };
    case c.JOURNAL_SAVE_SUCCESS:
      const { finalReflection, designSummary } = action.result.journal;
      return {
        ...state,
        finalReflection: finalReflection || state.finalReflection,
        designSummary: designSummary || state.designSummary
      };
    case c.JOURNAL_SELECT_PAGE:
      if (c.JOURNAL_VALID_PAGES.indexOf(action.page) >= 0) {
        return { ...state, selectedPage: action.page };
      } else {
        return state;
      }
    case c.JOURNAL_TOGGLE_DESIGN_SUMMARY:
      const showDesignSummary =
        action.show !== undefined
          ? action.show === true
          : !state.showDesignSummary;
      return { ...state, showDesignSummary };
    case c.JOURNAL_SELECT_REVISION:
      return {
        ...state,
        selectedConceptName: action.conceptName,
        selectedRevisionId: action.revisionId
      };
    default:
      return state;
  }
};

export default journal;
